import { Component, Input } from '@angular/core';
import { VehicleForm } from '../../forms/vehicle-form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-vehicle-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent
  ],
  templateUrl: './vehicle-form.component.html'
})
export class VehicleFormComponent {
  @Input()
  public form: VehicleForm | undefined;
}
